import * as React from "react";
import CeskaVesPage from "../../../components/customOrgs/senzacni/CeskaVesPage";

export default function CeskaVes() {
    return <CeskaVesPage />;
}
